/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Note_BodyInputs */

const en_dialog_note_body = /** @type {(inputs: Dialog_Note_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body`)
};

const es_dialog_note_body = /** @type {(inputs: Dialog_Note_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerpo`)
};

/**
* | output |
* | --- |
* | "Body" |
*
* @param {Dialog_Note_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_note_body = /** @type {((inputs?: Dialog_Note_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Note_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_note_body(inputs)
	return en_dialog_note_body(inputs)
});